module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-popover', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHint),
      expression: "showHint"
    }],
    ref: "popover",
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": _vm.hintValue
    }
  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
    attrs: {
      "label": "temp"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticClass: "glyphicon glyphicon-question-sign"
  }) : _vm._e()]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "headers": _vm.header,
      "on-success": _vm.onSuccess,
      "on-remove": _vm.onRemoveFile,
      "file-list": _vm.fileList,
      "action": _vm.resolveUrl(),
      "show-file-list": true,
      "on-preview": _vm.downloadFile,
      "multiple": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.attr.disableField
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("file")) + "\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'custom') ? _c('div', [_c('el-upload', {
    attrs: {
      "headers": _vm.header,
      "on-success": _vm.onSuccess,
      "on-remove": _vm.onRemoveFile,
      "file-list": _vm.fileList,
      "action": _vm.resolveUrl(),
      "on-preview": _vm.downloadFile,
      "multiple": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t("file")))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._l((_vm.value), function(attachment) {
    return _c('p', [_c('a', {
      attrs: {
        "href": _vm.urlDownloadFile(attachment.hash)
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon-cloud-download"
    }), _vm._v("\n        " + _vm._s(attachment.name) + "\n      ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('div', _vm._l((_vm.value), function(attachment) {
    return _c('a', {
      attrs: {
        "href": _vm.urlDownloadFile(attachment.hash)
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon-cloud-download"
    }), _vm._v("\n      " + _vm._s(attachment.name) + ",\n    ")])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-359d96d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderFile.vue
// module id = 912
// module chunks = 2